import
{
  ClubDropdownsContainer,
  SelectContainer,
  ButtonsContainer,
} from './ClubDropdownSelector.styles';
import { CustomSelect, CustomAutoSelect } from '../../Inputs/CustomSelect/CustomSelect';
import LinkButton from '../../Buttons/LinkButton/LinkButton';
import { Skeleton } from '@mui/material';

const getClubName = (id, options) =>
{
  if (id)
  {
    let club = options.find(e => { return e.id == id })
    if (club)
    {
      return club.label;
    }
  }
  return '';
}

const ClubDropdownSelector = ({ selected, dropdownOptions, onChange, handleReset, loading }) =>
{
  const handleChange = (e) => {
    e.preventDefault();
    onChange(e);
  };
  
  console.log(loading);
  console.log(selected, dropdownOptions,);
  return (
    <ClubDropdownsContainer>
      {!selected || selected.length == 0 &&
        <SelectContainer
          key={0}
        >
          <Skeleton variant="rounded" width={294} height={41}>
            <Skeleton variant="rectangular" width={294} height={41} sx={{ bgcolor: 'grey.900' }} />
          </Skeleton>

        </SelectContainer>
      }
      {
        selected && selected.length > 0 &&
        <SelectContainer
          key={0}
        >
          <CustomAutoSelect
            key={0}
            name={'club'}
            label="Clubs"
            placeholder={'Select option'}
            onChange={handleChange}
            value={getClubName(selected[0], dropdownOptions)}
            options={dropdownOptions}
            disabled={loading}
          />
        </SelectContainer>

      }

    </ClubDropdownsContainer >
  );
};

export default ClubDropdownSelector;
